import { SET_USER, SET_BALANCE } from '../actions/actionTypes';
import { UserAction } from '../actions/user';

export type UserReducer = {
    tmn_id: string;
    maximum_transfer_amount: number;
    monthly_limit: number;
    receiver_limit?: number;
    distinct_id: string;
    name: string;
    mobile_number: string;
    wallet_balance: number;
    pilot: null | boolean;
    agreement: {
        id: number;
        number: number;
        version: number;
        name: string;
        title: string;
        content: {
            url: string;
        };
        type_id: number;
    };
    nationality: string;
    document_type: string;
    occupation: string;
};

export type UserReducerState = {
    user: UserReducer;
};

const initialState: UserReducer = {
    tmn_id: '',
    distinct_id: '',
    name: '',
    mobile_number: '',
    wallet_balance: 0,
    pilot: null,
    agreement: {
        id: 0,
        number: 0,
        version: 0,
        name: '',
        title: '',
        content: {
            url: '',
        },
        type_id: 0,
    },
    maximum_transfer_amount: 0,
    monthly_limit: 0,
    nationality: '',
    document_type: '',
    occupation: '',
};

const user = (state = initialState, action: UserAction): UserReducer => {
    switch (action.type) {
        case SET_USER:
            return {
                ...state,
                ...action.payload,
            };
        case SET_BALANCE:
            return {
                ...state,
                ...action.payload,
            };

        default:
            return state;
    }
};

export default user;
